export function InitLineChartOptions(options) {

  var chartOptions = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false
  };

  chartOptions.scales = chartOptions.scales || {};
  chartOptions.scales.xAxes = chartOptions.scales.xAxes || [];
  chartOptions.scales.yAxes = chartOptions.scales.yAxes || [];

  chartOptions.scales.xAxes = [{
    ticks: {
      autoSkip: true,
      maxTicksLimit: 6
    }
  }];

  chartOptions.hover = chartOptions.hover || {};
  chartOptions.hover.mode = 'nearest';
  chartOptions.hover.interect = true;

  chartOptions.tooltips = chartOptions.tooltips || {};
  chartOptions.tooltips.mode = 'index';
  chartOptions.tooltips.interect = false;

  if (options) {
    if (options.xAxis) {
      if (chartOptions.scales.xAxes.length === 0) chartOptions.scales.xAxes.push({});
      chartOptions.scales.xAxes[0].scaleLabel = chartOptions.scales.xAxes[0].scaleLabel || {};
      chartOptions.scales.xAxes[0].scaleLabel.display = true;
      chartOptions.scales.xAxes[0].scaleLabel.labelString = options.xAxis;
      chartOptions.scales.xAxes[0].scaleLabel.fontSize = 18;
    }
    if (options.yAxis) {
      if (chartOptions.scales.yAxes.length === 0) chartOptions.scales.yAxes.push({});
      chartOptions.scales.yAxes[0].scaleLabel = chartOptions.scales.yAxes[0].scaleLabel || {};
      chartOptions.scales.yAxes[0].scaleLabel.display = true;
      chartOptions.scales.yAxes[0].scaleLabel.labelString = options.yAxis;
      chartOptions.scales.yAxes[0].scaleLabel.fontSize = 18;
    }
    if (options.dollarFormat && options.dollarFormat === true) {
      chartOptions.tooltips.callbacks = chartOptions.tooltips.callbacks || {};
      chartOptions.tooltips.callbacks.label = function (item, data) {
        var dataset = data.datasets[item.datasetIndex];
        var value = dataset.data[item.index];
        return dataset.label + ': $' + numberWithCommas(value.toFixed(2));
      }

      if (chartOptions.scales.yAxes.length === 0) chartOptions.scales.yAxes.push({});
      chartOptions.scales.yAxes[0].ticks = chartOptions.scales.yAxes[0].ticks || {};
      chartOptions.scales.yAxes[0].ticks.callback = function (value, index, values) {
        return '$' + numberWithCommas(value.toFixed(0));
      }
    }
    if (options.legend) {
      chartOptions.legend = chartOptions.legend || {};
      chartOptions.legend.display = true;
    }
  }

  return chartOptions;

}

export function InitBarChartOptions(options) {

  var chartOptions = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false
  };

  chartOptions.scales = chartOptions.scales || {};
  chartOptions.scales.xAxes = chartOptions.scales.xAxes || [];
  chartOptions.scales.yAxes = chartOptions.scales.yAxes || [];

  chartOptions.scales.xAxes = [{
    ticks: {
      autoSkip: true,
      maxTicksLimit: 6
    }
  }];

  if (options) {
    if (options.xAxis) {
      if (chartOptions.scales.xAxes.length === 0) chartOptions.scales.xAxes.push({});
      chartOptions.scales.xAxes[0].scaleLabel = chartOptions.scales.xAxes[0].scaleLabel || {};
      chartOptions.scales.xAxes[0].scaleLabel.display = true;
      chartOptions.scales.xAxes[0].scaleLabel.labelString = options.xAxis;
      chartOptions.scales.yAxes[0].scaleLabel.fontSize = 18;
    }
    if (options.yAxis) {
      if (chartOptions.scales.yAxes.length === 0) chartOptions.scales.yAxes.push({});
      chartOptions.scales.yAxes[0].scaleLabel = chartOptions.scales.yAxes[0].scaleLabel || {};
      chartOptions.scales.yAxes[0].scaleLabel.display = true;
      chartOptions.scales.yAxes[0].scaleLabel.labelString = options.yAxis;
      chartOptions.scales.yAxes[0].scaleLabel.fontSize = 18;
    }
    if (options.dollarFormat && options.dollarFormat === true) {
      chartOptions.tooltips = chartOptions.tooltips || {};
      chartOptions.tooltips.callbacks = chartOptions.tooltips.callbacks || {};
      chartOptions.tooltips.callbacks.label = function (item, data) {
        var dataset = data.datasets[item.datasetIndex];
        var value = dataset.data[item.index];
        return dataset.label + ': $' + numberWithCommas(value.toFixed(2));
      }

      if (chartOptions.scales.yAxes.length === 0) chartOptions.scales.yAxes.push({});
      chartOptions.scales.yAxes[0].ticks = chartOptions.scales.yAxes[0].ticks || {};
      chartOptions.scales.yAxes[0].ticks.callback = function (value, index, values) {
        if (!this.determinedDecimal) {
          this.determinedDecimal = true;
          if (values.length > 1) {
            this.determinedStepWidth = values[0] - values[1];
            this.determinedDecimal = ((this.determinedStepWidth % 1) !== 0);
          }
        }
        if (this.determinedDecimal) {
          return '$' + numberWithCommas(value.toFixed(2));
        }
        else {
          return '$' + numberWithCommas(value.toFixed(0));
        }
      }
    }
    if (options.swapAxes && options.swapAxes === 'true') {
      var temp = chartOptions.scales.yAxes;
      chartOptions.scales.yAxes = chartOptions.scales.xAxes;
      chartOptions.scales.xAxes = temp;
    }
  }

  return chartOptions;
}

export function InitHorizontalBarChartOptions(options) {

  var chartOptions = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false
  };

  chartOptions.scales = chartOptions.scales || {};
  chartOptions.scales.xAxes = chartOptions.scales.xAxes || [];
  chartOptions.scales.yAxes = chartOptions.scales.yAxes || [];

  chartOptions.scales.yAxes = [{
    ticks: {
      autoSkip: true,
      maxTicksLimit: 10
    }
  }];

  if (options) {
    if (options.xAxis) {
      if (chartOptions.scales.xAxes.length === 0) chartOptions.scales.xAxes.push({});
      chartOptions.scales.xAxes[0].scaleLabel = chartOptions.scales.xAxes[0].scaleLabel || {};
      chartOptions.scales.xAxes[0].scaleLabel.display = true;
      chartOptions.scales.xAxes[0].scaleLabel.labelString = options.xAxis;
      chartOptions.scales.yAxes[0].scaleLabel.fontSize = 18;
    }
    if (options.yAxis) {
      if (chartOptions.scales.yAxes.length === 0) chartOptions.scales.yAxes.push({});
      chartOptions.scales.yAxes[0].scaleLabel = chartOptions.scales.yAxes[0].scaleLabel || {};
      chartOptions.scales.yAxes[0].scaleLabel.display = true;
      chartOptions.scales.yAxes[0].scaleLabel.labelString = options.yAxis;
      chartOptions.scales.yAxes[0].scaleLabel.fontSize = 18;
    }
    if (options.dollarFormat && options.dollarFormat === true) {
      chartOptions.tooltips = chartOptions.tooltips || {};
      chartOptions.tooltips.callbacks = chartOptions.tooltips.callbacks || {};
      chartOptions.tooltips.callbacks.label = function (item, data) {
        var dataset = data.datasets[item.datasetIndex];
        var value = dataset.data[item.index];
        return dataset.label + ': $' + numberWithCommas(value.toFixed(2));
      }
      if (chartOptions.scales.yAxes.length === 0) chartOptions.scales.yAxes.push({});
      chartOptions.scales.yAxes[0].ticks = chartOptions.scales.yAxes[0].ticks || {};
      chartOptions.scales.yAxes[0].ticks.callback = function (value, index, values) {
        if (!this.determinedDecimal) {
          this.determinedDecimal = true;
          if (values.length > 1) {
            this.determinedStepWidth = values[0] - values[1];
            this.determinedDecimal = ((this.determinedStepWidth % 1) !== 0);
          }
        }
        if (this.determinedDecimal) {
          return '$' + numberWithCommas(value.toFixed(2));
        }
        else {
          return '$' + numberWithCommas(value.toFixed(0));
        }
      }
    }
    if (options.swapAxes && options.swapAxes === 'true') {
      var temp = chartOptions.scales.yAxes;
      chartOptions.scales.yAxes = chartOptions.scales.xAxes;
      chartOptions.scales.xAxes = temp;
    }
  }
  return chartOptions;
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}